const headerComponent = document.getElementsByClassName('header')[0];
const headerBottomComponent = document.querySelector('.header-bottom');

window.headerBottomScrollFunc = function headerBottomScrollFunc() {
  const headerBottom = document.querySelector('.header-bottom');

  if (!headerBottom) return;

  let closeFlag = false;

  const getLocalStorageState = localStorage.getItem('headerBottomSavedState');

  const headerBottomContent = headerBottom.querySelector(
    '.header-bottom__content'
  );
  const headerBottomToggleBtn = headerBottom.querySelector(
    '.header-bottom__toggle-btn'
  );

  const scrollCloseHeaderBottom = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const triggerPoint = window.innerHeight * 0.2;

    if (scrollY >= triggerPoint) {
      if (closeFlag !== true) {
        closeFlag = true;
        headerBottomContent.classList.remove('is-open-bottom-menu');
        headerBottomToggleBtn.classList.remove('is-open-bottom-menu');

        localStorage.setItem('headerBottomSavedState', 'close');
      }
    }
  };

  scrollCloseHeaderBottom();
  window.addEventListener('scroll', scrollCloseHeaderBottom);
};

window.headerBottomVisibleAnimation = function headerBottomVisibleAnimation() {
  if (headerBottomComponent) {
    headerBottomComponent.classList.add('is-visible');
    headerBottomScrollFunc();
    // footerScrollHiddenAnimation();
  }
};

if (headerComponent) {
  const additionalButtons = headerComponent.querySelector(
    '.menu-additional-content__buttons'
  );

  const headerBottom = document.querySelector('.header-bottom');

  const getLocalStorageState = localStorage.getItem('headerBottomSavedState');

  if (headerBottom) {
    const headerBottomContent = headerBottom.querySelector(
      '.header-bottom__content'
    );
    const headerBottomOpenBtn = headerBottom.querySelector(
      '.header-bottom__open-menu'
    );
    const headerBottomToggleBtn = headerBottom.querySelector(
      '.header-bottom__toggle-btn'
    );

    function headerBottomOpenMenu() {
      /*headerBottomContent.classList.remove('is-end-open-bottom-menu');*/
      headerBottomContent.classList.add('is-open-bottom-menu');
      headerBottomToggleBtn.classList.add('is-open-bottom-menu');

      localStorage.setItem('headerBottomSavedState', 'open');
    }

    function headerBottomCloseMenu() {
      headerBottomContent.classList.remove('is-open-bottom-menu');
      headerBottomToggleBtn.classList.remove('is-open-bottom-menu');

      localStorage.setItem('headerBottomSavedState', 'close');

      /*setTimeout(() => {
        headerBottomContent.classList.add('is-end-open-bottom-menu');
      }, 500);*/

      /*setTimeout(() => {
        headerBottomToggleBtn.classList.remove('is-open-bottom-menu');
      }, 700);*/
    }

    headerBottomToggleBtn.addEventListener('click', function () {
      if (headerBottomToggleBtn.classList.contains('is-open-bottom-menu')) {
        headerBottomCloseMenu();
      } else {
        headerBottomOpenMenu();
      }
    });

    headerBottomOpenBtn.addEventListener('click', function () {
      headerBottomOpenMenu();
    });
  }

  // Header scroll
  const scrollContainer = () => document.documentElement || document.body;

  document.addEventListener('scroll', () => {
    if (scrollContainer().scrollTop > 50) {
      headerComponent.classList.add('scrolled');
      headerBottomComponent?.classList.add('scrolled');
    } else if (scrollContainer().scrollTop == 0) {
      headerComponent.classList.remove('scrolled');
      headerBottomComponent?.classList.remove('scrolled');
    }
  });

  // menu handlers

  // check mobile menu show/hide condition
  const mobileMenuStartPoint = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--mobile-menu-start-point'
    )
  );
  let isMobileMenuEnable =
    window.outerWidth <= mobileMenuStartPoint ||
    document.querySelector('.header-mobile');

  // toggle menu handler
  function menuToggleFunc() {
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');

    menuToggle.classList.toggle('active');
    navbarNav.classList.toggle('active');
    headerComponent.classList.toggle('open-menu');
    headerCloseWrapper.classList.toggle('active');

    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (scrollLock.getScrollState()) {
      scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
      scrollLock.addScrollableSelector('.simplebar-content-wrapper');
      scrollLock.addScrollableSelector('.scroll-content');
    } else {
      scrollLock.enablePageScroll();
    }

    if (!menuToggle.classList.contains('active')) {
      scrollLock.enablePageScroll();
    }
  }

  // menu update function
  function updateMenu() {
    isMobileMenuEnable =
      window.outerWidth <= mobileMenuStartPoint ||
      document.querySelector('.mobile-header');

    if (!isMobileMenuEnable) {
      const dropdownMenus = document.querySelectorAll('.dropdown-menu');
      dropdownMenus.forEach((menu) => {
        menu.style.display = '';
      });

      const headerCloseWrapper = document.querySelector(
        '.header-close-wrapper'
      );
      headerCloseWrapper.classList.remove('active');

      const activeMenuItems = document.querySelectorAll('.menu-item.active');
      activeMenuItems.forEach((item) => {
        item.classList.remove('active');
      });

      const navbarNav = document.querySelector('.navbar-nav');
      navbarNav.classList.remove('active');

      headerComponent.classList.remove('open-menu');

      const menuToggle = document.querySelector('.menu-toggle');
      menuToggle.classList.remove('active');

      // LockScroll when burger open and enable when closed
      scrollLock.enablePageScroll();
    }

    if (additionalButtons) {
      if (window.innerWidth <= mobileMenuStartPoint) {
        const buttons = additionalButtons.querySelectorAll('.btn');
        buttons.forEach((button) => {
          button.classList.remove('outline');
        });
      } else {
        const buttons = additionalButtons.querySelectorAll('.btn');
        buttons.forEach((button) => {
          button.classList.add('outline');
        });
      }
    }
  }

  if (window.innerWidth <= mobileMenuStartPoint) {
    const buttons = additionalButtons.querySelectorAll('.btn');
    buttons.forEach((button) => {
      button.classList.remove('outline');
    });
  } else {
    const buttons = additionalButtons.querySelectorAll('.btn');
    buttons.forEach((button) => {
      button.classList.add('outline');
    });
  }

  window.addEventListener('resize', updateMenu);
  window.addEventListener('orientationchange', updateMenu);

  // end of toggle menu handler

  const menuToggle = document.querySelector('.menu-toggle');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');

  menuToggle.addEventListener('click', menuToggleFunc);
  headerCloseWrapper.addEventListener('click', menuToggleFunc);

  // Hide and show Header when scroll up
  function headerSticky() {
    let prevScrollPos = window.pageYOffset;

    window.onscroll = () => {
      const currentScrollPos = window.pageYOffset;
      const headerHeight = headerComponent.scrollHeight;

      if (window.scrollY > 0) {
        if (prevScrollPos > currentScrollPos) {
          /*headerComponent.style.top = 0;*/
          headerComponent.classList.add('scrolled');
          headerBottomComponent?.classList.add('scrolled');
          headerComponent.classList.remove('scrolled-content');
        } else {
          /*headerComponent.style.top = `-${headerHeight + 3}px`;*/
          headerComponent.classList.add('scrolled-content');
        }
      }

      if (window.scrollY === 0) {
        headerComponent.classList.remove('scrolled');
        headerBottomComponent?.classList.remove('scrolled');
      }

      prevScrollPos = currentScrollPos;
    };

    if (window.scrollY !== 0) {
      headerComponent.classList.add('scrolled');
      headerBottomComponent?.classList.add('scrolled');
    }
  }

  setTimeout(() => {
    headerSticky();
    initCountUp();
  }, 300);

  if (document.querySelector('.menu-dropdown')) {
    const menuDropdownArr = document.querySelectorAll('.menu-dropdown');
    menuDropdownArr.forEach((menuDropdown) => {
      const toggle = menuDropdown.querySelector('.menu-dropdown-toggle');
      const btn = toggle.querySelector('.menu-dropdown-btn');
      const content = menuDropdown.querySelector('.menu-dropdown-content');

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (!menuDropdown.classList.contains('active')) {
          menuDropdown.classList.add('active');
          headerComponent
            .querySelector('.navbar-nav')
            .classList.add('open-dropdown');
        } else {
          menuDropdown.classList.remove('active');
          headerComponent
            .querySelector('.navbar-nav')
            .classList.remove('open-dropdown');
        }
      });
    });
  }

  function opacityHeader() {
    headerComponent.classList.add('is-init');
    setTimeout(function () {
      headerComponent.style.opacity = 1;
    }, 300);
  }

  // document.fonts.ready.then(opacityHeader);

  window.addEventListener('load', opacityHeader);
}

window.closeMobMenu = function closeMobMenu() {
  if (headerComponent) {
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');

    menuToggle.classList.remove('active');
    navbarNav.classList.remove('active');
    headerComponent.classList.remove('open-menu');
    headerCloseWrapper.classList.remove('active');
  }
};

window.menuCloseFunc = function menuCloseFunc() {
  const menuToggle = document.querySelector('.menu-toggle');
  const navbarNav = document.querySelector('.navbar-nav');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');

  menuToggle.classList.remove('active');
  navbarNav.classList.remove('active');
  headerComponent.classList.remove('open-menu');
  headerCloseWrapper.classList.remove('active');

  scrollLock.enablePageScroll();
};

if (!document.querySelector('.bold-loader-new')) {
  headerBottomVisibleAnimation();
}
